import { STATICS } from 'statics'

export const WIFI_TIPS = [
  {
    text:
      'Use aparelhos aprovados e fornecidos pelo seu provedor para se conectar ao modem e ao Wi-Fi. Isso evita problemas de compatibilidade e suporte.',
  },
  {
    text:
      ' O melhor lugar para instalar o modem Wi-Fi é no centro da casa. Assim, o sinal chega mais fácil a vários cômodos.',
    src: STATICS.WIFI_BEST_PRACTICES_IMAGE,
    alt: 'Duas imagens sobre posicionamento de modem de wi-fi',
  },
  {
    text:
      ' O Wi-Fi é uma rede sem fio que conecta você à internet. Para que ele funcione bem, é bom evitar obstáculos como paredes grossas, espelhos, vidros e aparelhos que usam a mesma frequência. Isso ajuda a melhorar a conexão e a deixar o uso mais satisfatório.',
  },
]
